module.exports = "/images/social-media.svg?0c2fb6bf08b24f6529abb872840d62fb";